var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMSolicitudes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2eccb6;}.cls-2{fill:#329be6;}.cls-3{fill:#0b5c96;}.cls-4{fill:#fff;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_solicitudes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solicitudes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.72,32.72,48.25,15.25V45c0,7.92-6.13,13.25-15.25,13.25S17.75,52.92,17.75,45V41.66a5.24,5.24,0,0,1-4-5.08v-6A5.26,5.26,0,0,1,19,25.33a5.19,5.19,0,0,1,3.19,1.11A5.21,5.21,0,0,1,31,25.17a5.16,5.16,0,0,1,6.75-1.09V13a5.26,5.26,0,0,1,3.36-4.89L33.28.28a.4.4,0,0,0-.56,0L.28,32.72a.4.4,0,0,0,0,.56L32.72,65.72a.4.4,0,0,0,.56,0L65.72,33.28A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.72,12.72l2.53,2.53V13A5.26,5.26,0,0,0,43,7.75a5.38,5.38,0,0,0-1.89.36l2.17,2.17A2.73,2.73,0,0,1,45.72,12.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.75,13V24.08A5.16,5.16,0,0,0,31,25.17a5.21,5.21,0,0,0-8.81,1.27A5.19,5.19,0,0,0,19,25.33a5.26,5.26,0,0,0-5.25,5.25v6a5.24,5.24,0,0,0,4,5.08V45c0,7.92,6.13,13.25,15.25,13.25S48.25,52.92,48.25,45V15.25l-2.53-2.53a2.4,2.4,0,0,1,0,.28V37.28h-5.5V13A2.75,2.75,0,0,1,43,10.25l.28,0L41.11,8.11A5.26,5.26,0,0,0,37.75,13Zm-5.5,15.53a2.75,2.75,0,0,1,5.5,0v8.75h-5.5Zm-8,2v-2a2.75,2.75,0,0,1,5.5,0v8.75H27.42a1.66,1.66,0,0,0-1.21.52A1.6,1.6,0,0,0,25.77,39a2.73,2.73,0,0,1-1.52-2.44Zm-8,6v-6a2.75,2.75,0,0,1,5.5,0v6a2.75,2.75,0,0,1-5.5,0Zm29.5,3.2V45c0,5-3.34,10.75-12.75,10.75S20.25,50,20.25,45V41.66A5.21,5.21,0,0,0,23,39.91a5.2,5.2,0,0,0,3.32,1.8,8.9,8.9,0,0,0,7.41,5.67v1.27a.4.4,0,0,0,.4.4h1.7a.4.4,0,0,0,.4-.4V45.33a.4.4,0,0,0-.4-.4h-1.2a6.4,6.4,0,0,1-6.28-5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.25,13a2.75,2.75,0,0,1,5.5,0V37.28h-5.5V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35,25.78a2.75,2.75,0,0,1,2.75,2.75v8.75h-5.5V28.53A2.75,2.75,0,0,1,35,25.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.25,28.53a2.75,2.75,0,0,1,5.5,0v8.75H27.42a1.66,1.66,0,0,0-1.21.52A1.6,1.6,0,0,0,25.77,39a2.73,2.73,0,0,1-1.52-2.44v-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.25,36.58v-6a2.75,2.75,0,0,1,5.5,0v6a2.75,2.75,0,0,1-5.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33,55.75C23.59,55.75,20.25,50,20.25,45V41.66A5.21,5.21,0,0,0,23,39.91a5.2,5.2,0,0,0,3.32,1.8,8.9,8.9,0,0,0,7.41,5.67v1.27a.4.4,0,0,0,.4.4h1.7a.4.4,0,0,0,.4-.4V45.33a.4.4,0,0,0-.4-.4h-1.2a6.4,6.4,0,0,1-6.28-5.15H45.75V45C45.75,50,42.41,55.75,33,55.75Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMSolicitudes);
export default __webpack_public_path__ + "static/media/m_solicitudes.87dc062146698dac68cd208ccbf2d1e8.svg";
export { ForwardRef as ReactComponent };